// extracted by mini-css-extract-plugin
export var header = "QuickLinks-module--header--4lGX8";
export var icon = "QuickLinks-module--icon--z2cLt";
export var link = "QuickLinks-module--link--q1oWT";
export var list = "QuickLinks-module--list--voQjC";